import React from 'react';
import { Row, Col } from 'reactstrap';
import { T } from '../../../traks';

export const TermsAndConditions = ({ hasAcceptedTradeConditions, acceptTermsAndConditions, errors, ageError, siteName }) => {
  return (
    <React.Fragment>
      <Row className="mb-2 mt-2">
        <Col>
          <span className="ad_120_bold"><T>Terms and conditions</T></span>
        </Col>
      </Row>
      <Row className='mt-2 mb-5'>
        <Col>
          <div className="text-left">
            <label className="ad_custom_checkmark_container" style={{ paddingTop: "1px" }}>
              <input
                type="checkbox"
                checked={hasAcceptedTradeConditions}
                onChange={(e) => acceptTermsAndConditions(e.target.checked)}
              />
              <span className="ad_large_own_checkmark" />
            </label>
            <label className="d-inline">
              <span>
                <T>I confirm that I have read and accept</T> {siteName}s <a className='terms-and-conditions' target='_blank' rel="noopener noreferrer" href="https://undervisning.aktiedysten.dk/handelsbetingelser/"><T>terms and conditions, </T></a><T>and that I am at least 16 years old.</T>
              </span>
            </label>
          </div>
          {errors.tradeConditions && (
            <Row>
              <Col>
                <span className="text-danger form-error">{errors.tradeConditions}</span>
              </Col>
            </Row>
          )}
          {ageError && (
            <Row>
              <Col>
                <span className="text-danger form-error">{ageError}</span>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Checkout/TermsAndConditions.js